import React from 'react';
import { createRoot, Root } from "react-dom/client"
import { ModalCredits } from "scripts/components/react/ModalCredits/ModalCredits";

let root: Root | null = null;

export const renderModalCredits = () => {
  const body = document.querySelector("body")
  let modalContainer = document.querySelector(".js_modal_credits_root")

  if (!modalContainer) {
    modalContainer = document.createElement("div")
    modalContainer.classList.add("js_modal_credits_root")

    body.appendChild(modalContainer)
  }

  if (modalContainer) {
    if (!root) {
      root = createRoot(modalContainer)
    }
    root.unmount()
    root = createRoot(modalContainer)
    root.render(<ModalCredits />)
  }
}
